import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

const createCssVarRgbColors = colors => {
  function hexToRgb (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [
      parseInt(result[1], 16),
      parseInt(result[2], 16),
      parseInt(result[3], 16),
    ] : null;
  }

  Object.keys(colors).forEach(colorName => {
    const rgb = hexToRgb(colors[colorName]);
    if (rgb) {
      document.querySelector(':root').style.setProperty(`--v-${colorName}-rgb`, rgb.join(', '));
    }
  });
};

export default config => {
  createCssVarRgbColors(config.partnerTheme);

  return new Vuetify({
    theme: {
      options: {
        variations: false,
        customProperties: true,
      },
      themes: {
        light: config.partnerTheme,
      },
    },
  });
};
